import { render } from "./CampaignImageSlideCollection.vue?vue&type=template&id=1553837f"
import script from "./CampaignImageSlideCollection.vue?vue&type=script&lang=js"
export * from "./CampaignImageSlideCollection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__